const prepareLayers = values => {
  const layers = []

  return layers
}

export { prepareLayers }
